import {
  channelBadgeClass,
  channelLabel,
  type ReleaseChannel,
} from "@structura/core/release-metadata";
import { cn } from "@/lib/utils";

export function ReleaseEnvironmentBadge({
  channel,
  className,
  title,
}: {
  channel: ReleaseChannel;
  className?: string;
  title?: string;
}) {
  return (
    <span
      title={title ?? `Entorno: ${channelLabel(channel)}`}
      className={cn(
        "inline-flex items-center rounded border px-1.5 py-0.5 text-[10px] font-semibold tracking-wide",
        channelBadgeClass(channel),
        className,
      )}
    >
      {channelLabel(channel)}
    </span>
  );
}
